import { Button, Col, Row } from '@themesberg/react-bootstrap';
import React, { Fragment, useState, useEffect, useCallback } from 'react';
import FormAdditionalObs from '../../components/forms/inspection/form.additionalObs';
import FormInfoBodywork from '../../components/forms/inspection/form.bodywork';
import FormInfoChasis from '../../components/forms/inspection/form.chassisStructure';
import FormClaims from '../../components/forms/inspection/form.claims';
import FormFinalResult from '../../components/forms/inspection/form.finalResult';
import FormInfoFluids from '../../components/forms/inspection/form.fluids';
import FormGeneralInfo from '../../components/forms/inspection/form.infoClient';
import FormInfoVehicle from '../../components/forms/inspection/form.infoVehicle';
import FormMotorReport from '../../components/forms/inspection/form.motorReport';
import FormInfoPaint from '../../components/forms/inspection/form.paint';
import FormPropertyCard from '../../components/forms/inspection/form.propertycard';
import FormInfoTires from '../../components/forms/inspection/form.tires';
import FormVehiclePicture from '../../components/forms/inspection/form.vehiclePicture';
import FormVehiclePicturePlus from '../../components/forms/inspection/form.vehiclePicturePlus';
import FormSoatPicture from '../../components/forms/inspection/form.vehiclePictureSoat';
import FormTechPicture from '../../components/forms/inspection/form.vehiclePictureTec';
import FormAddObsComp from '../../components/forms/inspection/vehicleComponentsForms/form.additionalObs';
import FormCompBottom from '../../components/forms/inspection/vehicleComponentsForms/form.comp.bottomComp';
import FormCompCushions from '../../components/forms/inspection/vehicleComponentsForms/form.comp.cushions';
import FormCompElectric from '../../components/forms/inspection/vehicleComponentsForms/form.comp.electric';
import FormCompFluidLevels from '../../components/forms/inspection/vehicleComponentsForms/form.comp.fluidLevels';
import FormCompFluids from '../../components/forms/inspection/vehicleComponentsForms/form.comp.fluids';
import FormCompLights from '../../components/forms/inspection/vehicleComponentsForms/form.comp.ligths';
import FormCompMotorComp from '../../components/forms/inspection/vehicleComponentsForms/form.comp.motorComlement';
import { get } from '../../services/back.service';
import { useNavigate } from "react-router-dom";
import ModalMessage from "../../components/widgets/modalMessage";
import FormInfoTiresMoto from '../../components/forms/inspection/form.tiresMoto';
import FormCompFluidsMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.fluids';
import FormCompFluidLevelsMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.fluidLevels';
import FormCompCushionsMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.cushions';
import FormCompMotorCompMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.motorComlement';
import FormCompElectricMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.electric';
import FormCompLightsMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.ligths';
import FormCompBottomMoto from '../../components/forms/inspection/motoComponentsForms/form.comp.bottomComp';
import FormVehiclePictureRecord from '../../components/forms/inspection/form.vehiclePictureRecord';
import FormAccesories from '../../components/forms/inspection/form.accesories';
import FormOwnerHistoryReport from '../../components/forms/inspection/form.propertyReport';
import FormScannerSheetReport from '../../components/forms/inspection/form.scannerReport';
import FormScope from '../../components/collaboration/FormScope';
import PresenceBar from '../../components/collaboration/PresenceBar';
import useFinishInspection from '../../hooks/useFinishInspection';


function WebCreateInspection({ editid }) {
  //const {editid} = useParams();
  const [id, setId] = useState(0)
  const [vehicleclass, setVehicleclass] = useState(0)
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  // const [showEnd, setShowEnd]= useState(false)

  const [avaibleForms, setAvaibleForms] = useState({})

  const updateService = async (id_service) => {
    const respo = await get('/peritaje/forms/' + id_service)
    if (respo.success) setAvaibleForms(respo.data);
  }

  const validateHistoricPlate = async (id) => {
    const respo = await get('/peritaje/valid_history/' + id, {})
    if (respo.success) {
      const { data } = respo;
      if (data.count > 0) {
        setShowModal(true);
      }
    }
  }

  const goToReport = useCallback(() => navigate("/inspectionreport"), [navigate]);
  const { faltantes, finish: finishInspect, closeFaltantes } = useFinishInspection({
    inspectionId: id,
    onSuccess: goToReport,
  });

  const modelFunction = () => {
    setShowModal(false);
  }

  useEffect(() => { setId(editid) }, [editid]);
  return (
    <Fragment>
      {id !== 0 && (
        <Row>
          <Col>
            <PresenceBar inspectionId={id} />
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <FormScope scope="principal:" label="los datos generales">
            <FormGeneralInfo id={id} updateId={setId} updateService={updateService} setVehicleclass={setVehicleclass} validateHistoricPlate={validateHistoricPlate} />
          </FormScope>
          {avaibleForms[1] && (
            <FormScope scope="parts:C" label="la estructura (chasis)">
              <FormInfoChasis id={id} vehicleclass={vehicleclass} />
            </FormScope>
          )}
          {avaibleForms[2] && (
            <FormScope scope="parts:E" label="la carrocería">
              <FormInfoBodywork id={id} vehicleclass={vehicleclass} />
            </FormScope>
          )}
          {avaibleForms[3] && (
            <FormScope scope="fluids:F" label="los fluidos">
              <FormInfoFluids id={id} />
            </FormScope>
          )}
          {avaibleForms[4] && (
            <FormScope scope="tires:" label="las llantas">
              <FormInfoTires id={id} />
            </FormScope>
          )}
          {avaibleForms[17] && (
            <FormScope scope="tires:" label="las llantas (moto)">
              <FormInfoTiresMoto id={id} />
            </FormScope>
          )}
          {avaibleForms[5] && (
            <FormScope scope="paint:P" label="la pintura">
              <FormInfoPaint id={id} />
            </FormScope>
          )}
          {avaibleForms[6] && (
            <FormScope scope="pictures:PC" label="la cédula del vehículo">
              <FormPropertyCard id={id} />
            </FormScope>
          )}
          {avaibleForms[19] && (
            <FormScope scope="accesories:" label="los accesorios">
              <FormAccesories id={id} />
            </FormScope>
          )}
          {avaibleForms[7] && (
            <FormScope scope="header:vehicle" label="la información del vehículo">
              <FormInfoVehicle id={id} />
            </FormScope>
          )}
          {avaibleForms[8] && (
            <FormScope scope="pictures:CI" label="las fotografías del vehículo">
              <FormVehiclePicture id={id} />
            </FormScope>
          )}
          {avaibleForms[9] && (
            <>
              <FormScope scope="components:FC" label="los fluidos de componentes">
                <FormCompFluids id={id} />
              </FormScope>
              <FormScope scope="components:FL" label="los niveles de fluidos">
                <FormCompFluidLevels id={id} />
              </FormScope>
              <FormScope scope="components:MC" label="el complemento del motor">
                <FormCompMotorComp id={id} />
              </FormScope>
              <FormScope scope="components:BC" label="el montaje inferior">
                <FormCompBottom id={id} />
              </FormScope>
              <FormScope scope="components:CC" label="los cojines">
                <FormCompCushions id={id} />
              </FormScope>
              <FormScope scope="components:EC" label="el sistema eléctrico">
                <FormCompElectric id={id} />
              </FormScope>
              <FormScope scope="components:LC" label="las luces">
                <FormCompLights id={id} />
              </FormScope>
            </>
          )}
          {avaibleForms[18] && (
            <>
              <FormScope scope="components:FC" label="los fluidos (moto)">
                <FormCompFluidsMoto id={id} />
              </FormScope>
              <FormScope scope="components:FL" label="los niveles de fluidos (moto)">
                <FormCompFluidLevelsMoto id={id} />
              </FormScope>
              <FormScope scope="components:MC" label="el complemento del motor (moto)">
                <FormCompMotorCompMoto id={id} />
              </FormScope>
              <FormScope scope="components:BC" label="el montaje inferior (moto)">
                <FormCompBottomMoto id={id} />
              </FormScope>
              <FormScope scope="components:CC" label="los cojines (moto)">
                <FormCompCushionsMoto id={id} />
              </FormScope>
              <FormScope scope="components:EC" label="el sistema eléctrico (moto)">
                <FormCompElectricMoto id={id} />
              </FormScope>
              <FormScope scope="components:LC" label="las luces (moto)">
                <FormCompLightsMoto id={id} />
              </FormScope>
            </>
          )}
          {(avaibleForms[9] || avaibleForms[18]) && (
            <FormScope scope="header:obsComp" label="las observaciones de componentes">
              <FormAddObsComp id={id} />
            </FormScope>
          )}
          {avaibleForms[14] && (
            <FormScope scope="header:obs" label="las observaciones adicionales">
              <FormAdditionalObs id={id} />
            </FormScope>
          )}
          {avaibleForms[10] && (
            <FormScope scope="claims:" label="las reclamaciones">
              <FormClaims id={id} />
            </FormScope>
          )}
          {avaibleForms[11] && (
            <FormScope scope="attach:MR" label="el reporte de motor">
              <FormMotorReport id={id} />
            </FormScope>
          )}
          {avaibleForms[20] && (
            <FormScope scope="attach:OH" label="el historial del propietario">
              <FormOwnerHistoryReport id={id} />
            </FormScope>
          )}
          {avaibleForms[21] && (
            <FormScope scope="attach:SS" label="las hojas escaneadas">
              <FormScannerSheetReport id={id} />
            </FormScope>
          )}
          {avaibleForms[13] && (
            <>
              <FormScope scope="pictures:AI" label="las fotografías adicionales">
                <FormVehiclePicturePlus id={id} />
              </FormScope>
              <FormScope scope="pictures:RI" label="las fotografías de registro">
                <FormVehiclePictureRecord id={id} />
              </FormScope>
            </>
          )}
          {avaibleForms[15] && (
            <FormScope scope="pictures:TM" label="la foto del SOAT">
              <FormSoatPicture id={id} />
            </FormScope>
          )}
          {avaibleForms[16] && (
            <FormScope scope="pictures:SO" label="la foto de la ficha técnica">
              <FormTechPicture id={id} />
            </FormScope>
          )}
          {avaibleForms[12] && (
            <FormScope scope="header:result" label="la calificación final">
              <FormFinalResult id={id} />
            </FormScope>
          )}
          {id !== 0 && (
            <div className="mt-2 d-grid gap-2">
              <Button onClick={finishInspect} size="lg">
                Finalizar Peritaje
              </Button>
            </div>
          )}
        </Col>
      </Row>
      <ModalMessage
        title={'Advertencia'}
        text={`Esta placa tiene un peritaje en el historial, por favor revisar`}
        showProps={showModal}
        funcAccept={modelFunction}
        funcClose={modelFunction}
      />
      <ModalMessage
        title={'Faltantes del peritaje'}
        text={faltantes || ''}
        showProps={!!faltantes}
        funcAccept={closeFaltantes}
        funcClose={closeFaltantes}
      />
    </Fragment>)
}

export default WebCreateInspection;
